module.exports = __webpack_public_path__ + "img/loading.c1011060.gif";